import { Outlet, Link } from "react-router-dom";
import { Fragment, useContext } from "react";
import { ReactComponent as CrwnLogo } from  "../../../assets/crown.svg"; 
import { useSelector } from 'react-redux';

import { CartContext } from "../../../contexts/cart.context";
import { selectCurrentUser } from "../../../store/user/user.selector";
import { signOutUser } from "../../../utils/firebase.utils";

import CartIcon from "../../../components/cart-icon/cart-icon.component";
import CartdDropdown from "../../../components/cart-dropdown/cart-dropdown.component";

import "./navigation.styles.scss"

const Navigation = () => {
  const currentUser = useSelector(selectCurrentUser);
  const { isCartOpen } = useContext(CartContext);

  return (
    <Fragment>
      <div className="navigation">
        <Link className="logo-container" to="/">
          <CrwnLogo className="logo" />
        </Link>
        <div className="nav-links-container">
          <Link className="nav-link" to="/shop">
            SHOP
          </Link>
          {
            currentUser ? (
              <span className="nav-link" onClick={signOutUser}>SIGN OUT</span>
            )
            : (
              <Link className="nav-link" to="/auth">
                SIGN IN
              </Link>
            )
          }
          <CartIcon />
        </div>
        
        {isCartOpen && <CartdDropdown />}
      </div>
      <Outlet />
    </Fragment>
  )
}

export default Navigation;
